import React, { useState } from "react";
import "./Event_Details_Content.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
import Pink_Btn from "../../common/common_btn/pink_btn/Pink_Btn";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import Orange_Btn from "../../common/common_btn/orange_btn/Orange_Btn";

const Event_Details_Content = () => {
  const navigate = useNavigate();
  const [selectedLang, setSelectedLang] = useState("English");

  const handleSelect = (eventKey) => {
    setSelectedLang(eventKey);
  };

  return (
    <>
      <section className="Event_Details_Content">
        <div className="container">
          <div className="title_div">
            <h5 className="sadtitle">Experience the Divine</h5>
            <p className="sadsubtitle">A Day at the Ashram!</p>
          </div>

          <div className="row mt-lg-2 mt-2">
            <div className="col-lg-12 mx-auto">
              <Common_Title_2 subText={"About"} />

              <p className="sadurucont">
                Sadguru Arpanam is a sacred expression of complete surrender,
                love, & thankfulness to the revered Sadguru. It signifies
                offering every breath, every thought, and every action at the
                lotus feet of the Master not out of duty, but out of deep
                devotion.
              </p>
              <p className="sadurucont">
                In this spiritual gesture, devotees offer not just material
                things but also their ego, desires, and doubts, allowing the
                Guru’s light to guide their path.
              </p>
              <p className="sadurucont">
                It is an acknowledgment that the Guru is the gateway to truth,
                the remover of darkness, and the giver of inner freedom.
              </p>

              <div className="dailyprocessdiv">
                <div className="leftdiv">
                  <h6 className="dailyh6">Daily Process</h6>
                </div>
                <div className="middiv"></div>
                <div className="lastdiv">
                  <p className="date">
                    <img
                      className="calicon"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icons/calender.png"
                      }
                      alt="calender"
                    />
                    4 to 10 July
                  </p>
                </div>
              </div>

              <div className="tablediv">
                <h5 className="morningh5">Morning Sadhana</h5>
                <div className="table-responsive">
                  <table className="table table-striped ">
                    <thead>
                      <tr>
                        <th>Sr.No.</th>
                        <th>Practice</th>
                        <th>Time</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Guru pooja</td>
                        <td>5:30 am</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Guru pooja</td>
                        <td>5:30 am</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Guru pooja</td>
                        <td>5:30 am</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Guru pooja</td>
                        <td>5:30 am</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="tablediv mt-5">
                <h5 className="morningh5">Guidelines</h5>
                <div className="guidelinesdiv">
                  <h6 className="offh6">
                    Offer with a pure heart, serve with devotion, & surrender
                    every action at the Guru’s feet.
                  </h6>

                  <ul className="uldata">
                    <li>Keep your body, mind & surroundings clean</li>
                    <li>Offer with selfless devotion, not desire</li>
                    <li>Stay silent and inwardly focused</li>
                    <li>Respect all and follow with discipline</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="register_now_div">
            <div className="left_side_div">
              <div className="lang_div">
                <Dropdown onSelect={handleSelect}>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    {selectedLang}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="English">English</Dropdown.Item>
                    <Dropdown.Item eventKey="Hindi">Hindi</Dropdown.Item>
                    <Dropdown.Item eventKey="Marathi">Marathi</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <p className="price_text">₹ 5699</p>
            </div>
            <div className="register_btn_div">
              <Orange_Btn
                btnText={"Register Now"}
                onClick={() => {
                  navigate("/personal-info-form");
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Event_Details_Content;
